module.exports = __webpack_public_path__ + "static/media/998782.73c9305f.png";